import { AsyncPipe } from '@angular/common'
import { Component, Input } from '@angular/core'
import moment from 'moment'
import { interval, map } from 'rxjs'

@Component({
  selector: 'app-time',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.scss'],
})
export class TimeComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'small'
  @Input() color: 'light' | 'dark' = 'dark'
  time$ = interval(1000).pipe(map(() => moment().format('LT')))
}
